export class ErrorCode {
  static readonly DUPLICATE = 'DUPLICATE';
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/error-code.ts